import i18n from '@/libs/i18n'

export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    meta: {
      pageTitle: i18n.t('Dashboard'),
      action: 'read',
      resource: 'dashboard',
    },
  },
]
